<template>
  <div class="writtenStatus">
    <el-card>
      <p style="margin-bottom: 40px">注意：配置笔试资格，开启后即视为生效，可多选开启。</p>
      <p v-for="(item, index) in list" :key="item.id" style="font-size: 16px; margin: 20px 0">
        <template v-if="index === 0">
          <el-row type="flex" align="middle">
            完成基础课程&nbsp;
            <el-input v-model="boundedValue" size="mini" style="width:80px" />
            &nbsp;%学习时可预约理论考试&emsp;
            <el-button type="primary" size="mini" @click="handleChangeDegree(item)">更新</el-button>
          </el-row>
          <el-row type="flex" align="middle" style="margin-top:10px">
            完成基础课程&nbsp;
            <el-input v-model="boundedPracticalValue" size="mini" style="width:80px" />
            &nbsp;%学习时可预约实操能力考核&emsp;
            <el-button type="primary" size="mini" @click="handleChangePracticalDegree(item)">更新</el-button>
          </el-row>
        </template>
        <template v-else>
          {{ item.remarks }}
          <el-switch
            v-model="item.status"
            active-color="#13ce66"
            inactive-color="#ff4949"
            :active-value="1"
            :inactive-value="2"
            style="margin-left: 10px;"
            @change="changeStatus(item)">
          </el-switch>
        </template>
      </p>
    </el-card>
  </div>
</template>

<script>
import { getListTestConf, updateTestConf, updatePracticalConf } from '@/api/product/written'
export default {
  name: 'WrittenStatus',
  data () {
    return {
      degree: 0,
      practicalDegree: 0,
      list: []
    }
  },
  computed: {
    boundedValue: {
      get() {
        return this.degree
      },
      set(value) {
        if (value) {
          const numValue = Number(value.replace(/^(0+)|[^\d]/g,''))
          if (!isNaN(numValue) && numValue >= 0 && numValue <= 100) {
            this.degree = numValue
          } else {
            this.degree = Math.max(0, Math.min(100, numValue))
          }
        } else {
          this.degree = ''
        }
      }
    },
    boundedPracticalValue: {
      get() {
        return this.practicalDegree
      },
      set(value) {
        if (value) {
          const numValue = Number(value.replace(/^(0+)|[^\d]/g,''))
          if (!isNaN(numValue) && numValue >= 0 && numValue <= 100) {
            this.practicalDegree = numValue
          } else {
            this.practicalDegree = Math.max(0, Math.min(100, numValue))
          }
        } else {
          this.practicalDegree = ''
        }
      }
    }
  },
  created() {
    this.getList()
  },
  methods: {
    async getList() {
      const res = await getListTestConf()
      this.list = res.data
      const [ i ] = this.list
      if (i && i.degree) {
        this.degree = i.degree
      }
      if (i && i.practicalDegree) {
        this.practicalDegree = i.practicalDegree
      }
    },
    async changeStatus(item) {
      const res = await updateTestConf({id: item.id, status: item.status})
      this.$message.success('操作成功!')
      this.getList()
    },
    handleChangeDegree (item) {
      if (this.degree !== 0 && !this.degree) {
        this.$message.warning('请输入百分比后更新!')
        return
      }
      const params = {
        id: item.id,
        status: 1,
        degree: this.degree
      }
      updateTestConf(params).then(({ code }) => {
        if (code === 0) {
          this.$message.success('操作成功!')
          this.getList()
        }
      })
    },
    handleChangePracticalDegree (item) {
      if (this.practicalDegree !== 0 && !this.practicalDegree) {
        this.$message.warning('请输入百分比后更新!')
        return
      }
      const params = {
        id: item.id,
        practicalDegree: this.practicalDegree
      }
      updatePracticalConf(params).then(({ code }) => {
        if (code === 0) {
          this.$message.success('操作成功!')
          this.getList()
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
